import { useQuery } from "@tanstack/react-query";
import { Api } from "../openApi";

export type VariableInsuranceRankProps = {
  age: number;
  sex: number;
  intentionRecommendInsurance: boolean;
  baseCode?: string;
  onSuccess?: () => void;
};

export const useVariableInsuranceRank = (params: VariableInsuranceRankProps) => {

  return useQuery(
    ["getVariableInsuranceRank", params],
    async () => {
      const { data } = await Api.getApiVariableInsurancesRank(
        params.age,
        params.sex,
        params.intentionRecommendInsurance,
        params.baseCode
      );
      params.onSuccess && params.onSuccess();
      return data;
    },
    { enabled: false }
  );
};
